import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NavigationItem, NavigationItems } from '../navigation';
import { Location, LocationStrategy } from '@angular/common';
import { GradientConfig } from 'src/app/app-config';
import { environment } from 'src/environments/environment';
import { AuthService } from '@shared/services/auth.service';

@Component({
  selector: 'app-nav-content',
  templateUrl: './nav-content.component.html',
  styleUrls: ['./nav-content.component.scss'],
})
export class NavContentComponent implements OnInit {
  // version
  title = 'Demo application for version numbering';
  currentApplicationVersion = environment.appVersion;

  // public pops
  navigations: NavigationItem[];
  prevDisabled: string;
  nextDisabled: string;
  contentWidth: number;
  wrapperWidth!: number;
  scrollWidth: number;
  windowWidth: number;

  @Output() NavMobCollapse = new EventEmitter();

  @ViewChild('navbarContent', { static: false }) navbarContent!: ElementRef;
  @ViewChild('navbarWrapper', { static: false }) navbarWrapper!: ElementRef;

  // constructor
  constructor(
    private location: Location,
    private locationStrategy: LocationStrategy,
    private _authService: AuthService,
  ) {
    this.navigations = NavigationItems;
    this.windowWidth = window.innerWidth;
    this.prevDisabled = 'disabled';
    this.nextDisabled = '';
    this.scrollWidth = 0;
    this.contentWidth = 0;
  }

  // life cycle event
  ngOnInit() {
    this.filterMenuItems();

    if (this.windowWidth < 992) {
      setTimeout(() => {
        document
          .querySelector('.pcoded-navbar')
          ?.classList.add('menupos-static');
        (
          document.querySelector('#nav-ps-gradient-able') as HTMLElement
        ).style.maxHeight = '100%';
      }, 500);
    }
  }

  // public method
  scrollPlus() {
    this.scrollWidth = this.scrollWidth + (this.wrapperWidth - 80);
    if (this.scrollWidth > this.contentWidth - this.wrapperWidth) {
      this.scrollWidth = this.contentWidth - this.wrapperWidth + 80;
      this.nextDisabled = 'disabled';
    }
    this.prevDisabled = '';
    if (GradientConfig.isRtlLayout) {
      (
        document.querySelector('#side-nav-horizontal') as HTMLElement
      ).style.marginRight = '-' + this.scrollWidth + 'px';
    } else {
      (
        document.querySelector('#side-nav-horizontal') as HTMLElement
      ).style.marginLeft = '-' + this.scrollWidth + 'px';
    }

    console.log('window width - ', this.windowWidth);
    console.log('content width - ', this.contentWidth);
    console.log('wrapper width - ', this.wrapperWidth);
    console.log('scroll width - ', this.scrollWidth);
  }

  scrollMinus() {
    this.scrollWidth = this.scrollWidth - this.wrapperWidth;
    if (this.scrollWidth < 0) {
      this.scrollWidth = 0;
      this.prevDisabled = 'disabled';
    }
    this.nextDisabled = '';

    (
      document.querySelector('#side-nav-horizontal') as HTMLElement
    ).style.marginLeft = '-' + this.scrollWidth + 'px';
  }

  fireLeave() {
    const sections = document.querySelectorAll('.pcoded-hasmenu');
    for (let i = 0; i < sections.length; i++) {
      sections[i].classList.remove('active');
      sections[i].classList.remove('pcoded-trigger');
    }

    let current_url = this.location.path();
    const baseHref = this.locationStrategy.getBaseHref();
    if (baseHref) {
      current_url = baseHref + this.location.path();
    }
    const link = "a.nav-link[ href='" + current_url + "' ]";
    const ele = document.querySelector(link);
    if (ele !== null && ele !== undefined) {
      const parent = ele.parentElement;
      const up_parent = parent?.parentElement?.parentElement;
      const last_parent = up_parent?.parentElement;
      if (parent?.classList.contains('pcoded-hasmenu')) {
        parent.classList.add('active');
      } else if (up_parent?.classList.contains('pcoded-hasmenu')) {
        up_parent.classList.add('active');
      } else if (last_parent?.classList.contains('pcoded-hasmenu')) {
        last_parent.classList.add('active');
      }
    }
  }

  navMob() {
    if (
      this.windowWidth < 992 &&
      document
        .querySelector('app-navigation.pcoded-navbar')
        ?.classList.contains('mob-open')
    ) {
      this.NavMobCollapse.emit();
    }
  }

  fireOutClick() {
    let current_url = this.location.path();
    const baseHref = this.locationStrategy.getBaseHref();
    if (baseHref) {
      current_url = baseHref + this.location.path();
    }
    const link = "a.nav-link[ href='" + current_url + "' ]";
    const ele = document.querySelector(link);
    if (ele !== null && ele !== undefined) {
      const parent = ele.parentElement;
      const up_parent = parent?.parentElement?.parentElement;
      const last_parent = up_parent?.parentElement;
      if (parent?.classList.contains('pcoded-hasmenu')) {
        if (GradientConfig.layout === 'vertical') {
          parent.classList.add('pcoded-trigger');
        }
        parent.classList.add('active');
      } else if (up_parent?.classList.contains('pcoded-hasmenu')) {
        if (GradientConfig.layout === 'vertical') {
          up_parent.classList.add('pcoded-trigger');
        }
        up_parent.classList.add('active');
      } else if (last_parent?.classList.contains('pcoded-hasmenu')) {
        if (GradientConfig.layout === 'vertical') {
          last_parent.classList.add('pcoded-trigger');
        }
        last_parent.classList.add('active');
      }
    }
  }

  filterMenuItems() {
    this.navigations = this.navigations
      .filter(item => this.isItemVisible(item))
      .map(item => {
        if (item.children) {
          item.children = this.filterSubItems(item.children);
        }

        return item;
      })
      // Un grupo puede quedar sin hijos visibles cuando todos sus hijos
      // requieren roles que el usuario no tiene (p. ej. Recibos para un
      // usuario sin acceso a Historial ni a Generar recibos).
      .filter(item => !item.children || item.children.length > 0);
  }

  private filterSubItems(subItems: NavigationItem[]): NavigationItem[] {
    return subItems.filter(sub => this.isItemVisible(sub));
  }

  /**
   * Evalúa `roles` según `roleSource`: `'legacy'` (por defecto) consulta el
   * rol principal (`identity.rol`); `'assigned'` consulta los roles
   * asignados (`identity.roles`). Ver NavigationItem.roleSource.
   */
  private isItemVisible(item: NavigationItem): boolean {
    if (!item.roles) {
      return true;
    }

    if (item.roleSource === 'assigned') {
      return this._authService.hasAnyAssignedRole(item.roles);
    }

    return this._authService.isUserAllowed(item.roles);
  }
}
